import styled from 'styled-components/macro';
import { device } from '../../device';


export const StyledHeading = styled.h1`

    line-height:1;
    margin:0;
    padding:0;
    font-size: 1.56rem;
    color: #8B8B8B;
    letter-spacing: -0.6px;
    text-align: center;
    font-weight:bold;
    padding-bottom:15px;
    @media ${device.tablet} {
        text-align:left;
    }

`;